"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Budget = exports.BudgetProvider = exports.Limit = void 0;
const typescript_json_serializer_1 = require("typescript-json-serializer");
let Limit = class Limit {
    constructor(count, timeWindow) {
        this.count = count;
        this.timeWindow = timeWindow;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "count" }),
    __metadata("design:type", String)
], Limit.prototype, "count", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "timeWindow" }),
    __metadata("design:type", String)
], Limit.prototype, "timeWindow", void 0);
Limit = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String])
], Limit);
exports.Limit = Limit;
let BudgetProvider = class BudgetProvider {
    constructor(providerId, currency, costPerMessage, totalMessageCountLimit, totalCostLimit, isDefault) {
        this.providerId = providerId;
        this.currency = currency;
        this.costPerMessage = costPerMessage;
        this.totalMessageCountLimit = totalMessageCountLimit;
        this.totalCostLimit = totalCostLimit;
        this.default = isDefault;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "providerId" }),
    __metadata("design:type", String)
], BudgetProvider.prototype, "providerId", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "currency" }),
    __metadata("design:type", String)
], BudgetProvider.prototype, "currency", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "costPerMessage" }),
    __metadata("design:type", String)
], BudgetProvider.prototype, "costPerMessage", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "totalMessageCountLimit", type: Limit }),
    __metadata("design:type", Limit)
], BudgetProvider.prototype, "totalMessageCountLimit", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "totalCostLimit", type: Limit }),
    __metadata("design:type", Limit)
], BudgetProvider.prototype, "totalCostLimit", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "default" }),
    __metadata("design:type", Boolean)
], BudgetProvider.prototype, "default", void 0);
BudgetProvider = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, String, Limit,
        Limit, Boolean])
], BudgetProvider);
exports.BudgetProvider = BudgetProvider;
let Budget = class Budget {
    constructor(channel, providers) {
        this.channel = channel;
        this.providers = providers;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "channel" }),
    __metadata("design:type", String)
], Budget.prototype, "channel", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: "providers", type: BudgetProvider }),
    __metadata("design:type", Array)
], Budget.prototype, "providers", void 0);
Budget = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, Array])
], Budget);
exports.Budget = Budget;
